export default "__VITE_ASSET__Dr4h0yIa__"